exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_object-gops.js
// module id = 46
// module chunks = 0